import { render, staticRenderFns } from "./dangerJournalImpr.vue?vue&type=template&id=683e3454"
import script from "./dangerJournalImpr.vue?vue&type=script&lang=js"
export * from "./dangerJournalImpr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('683e3454')) {
      api.createRecord('683e3454', component.options)
    } else {
      api.reload('683e3454', component.options)
    }
    module.hot.accept("./dangerJournalImpr.vue?vue&type=template&id=683e3454", function () {
      api.rerender('683e3454', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/danger/dangerJournalImpr.vue"
export default component.exports